<template>
  <v-layout wrap>
    <v-flex xs12>
      <div class="display-1 font-weight-bold" id="about">This is me</div>
    </v-flex>
    <v-row no-gutters>
      <v-col cols="12" sm="6" md="7">
        <v-sheet
          color="white"
          elevation="2"
          height="100%"
          shaped
          width="80%"
          ><div class="body-1 pt-5 pl-5 pr-5 pb-5">{{ description }}</div>
          <div class="body-1 pt-5 pl-5 pr-5 pb-5">
            Working on starting an app development business and always looking
            for new clients! Would love to talk to you about your idea.
          </div></v-sheet
        >
      </v-col>
      <v-col cols="6" md="5">
        <v-img
          src="../assets/andreas2.png"
          class="ml-5"
          max-height="400"
          max-width="400"
        />
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  name: "ThisIsMe",
  data() {
    return {
      aboutText:
        "I enjoy building apps in my free time when I'm not doing much. Looking to get into machine learning and trying to automate as many things as possible. Love to encourage new coders that they can do it too! I'm not very smart, just curious to see how things work. I'm also not that good of a writer as you can see. lol. Anyways, you are free to download any of the code thats on my github! And I hope you have a great day!",
      description: "",
    };
  },
  methods: {
    setDescription(data) {
      this.description = data;
    },
  },
  mounted() {
    axios.get("api/description-public/1").then((response) => {
      this.setDescription(response.data.data.description);
    });
  },
};
</script>